import { render } from "./ModalFaqEdit.vue?vue&type=template&id=5e2bfce2&scoped=true"
import script from "./ModalFaqEdit.vue?vue&type=script&lang=js"
export * from "./ModalFaqEdit.vue?vue&type=script&lang=js"

import "./ModalFaqEdit.vue?vue&type=style&index=0&id=5e2bfce2&scoped=true&lang=css"

import exportComponent from "/Users/yao/Documents/projects/garden/garden_ts/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e2bfce2"]])

export default __exports__